import { render, staticRenderFns } from "./UniversalTableViewModeSelector.vue?vue&type=template&id=383429c2&scoped=true"
import script from "./UniversalTableViewModeSelector.vue?vue&type=script&lang=js"
export * from "./UniversalTableViewModeSelector.vue?vue&type=script&lang=js"
import style0 from "./UniversalTableViewModeSelector.vue?vue&type=style&index=0&id=383429c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383429c2",
  null
  
)

export default component.exports